// import React, { createContext, useContext, useState, useEffect } from "react";

// const AuthContext = createContext(null);

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);

//   // לטעון משתמש ששמור ב-localStorage (אם יש)
//   useEffect(() => {
//     const saved = localStorage.getItem("app_user");
//     if (saved) {
//       setUser(JSON.parse(saved));
//     }
//   }, []);

//   const login = (userData) => {
//     setUser(userData);
//     localStorage.setItem("app_user", JSON.stringify(userData));
//   };

//   const logout = () => {
//     setUser(null);
//     localStorage.removeItem("app_user");
//   };

//   return (
//     <AuthContext.Provider value={{ user, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);






import React, { createContext, useContext, useState, useEffect } from "react";
import { base44 } from "@/api/base44Client"; 

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const refreshMe = async () => {
    const token = localStorage.getItem("auth_token");
    if (!token) return null;
  
    const freshUser = await base44.auth.me();
    if (freshUser) {
      setUser(freshUser);
      localStorage.setItem("app_user", JSON.stringify(freshUser));
    }
    return freshUser;
  };
  
  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    const storedUser = localStorage.getItem("app_user");

    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (_) {}
    }

    setLoading(false);

    if (token) {
      base44.auth.me()
        .then((freshUser) => {
          if (freshUser) {
            setUser(freshUser);
            localStorage.setItem("app_user", JSON.stringify(freshUser));
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            setUser(null);
            localStorage.removeItem("app_user");
            localStorage.removeItem("auth_token");
            // אל תעשה הפניה ל-login כשאין אינטרנט — נשארים באפליקציה (למשל בסל)
            if (typeof navigator !== "undefined" && navigator.onLine) {
              window.location.href = "/login";
            }
          }
        });
    }
  }, []);
  

  const login = (userData, token) => {
    // אם השרת לא החזיר טוקן חדש, נשמור על הקיים
    if (token) localStorage.setItem("auth_token", token);
    
    setUser(userData);
    localStorage.setItem("app_user", JSON.stringify(userData));
    
    // ביטול מצב הטעינה כדי לאפשר לאפליקציה לרנדר את הדפים המוגנים
    setLoading(false); 
  };
  

  // --- הפונקציה שמתקנת את כפתור ההתנתקות ---
  const logout = () => {
    console.log("🔒 Logging out...");
    setUser(null);
    localStorage.removeItem("app_user");
    localStorage.removeItem("auth_token");
    if (typeof navigator !== "undefined" && navigator.onLine) {
      window.location.href = "/login"; // רענון מלא ומעבר לדף התחברות רק כשיש רשת
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshMe, loading, isAuthenticated: !!user }}>
      {/* הוספת מעטפת יציבה עם מפתח קבוע מונעת מ-React לאבד את המיקום ב-DOM */}
      <div key="app-auth-wrapper" className={loading ? undefined : "h-full"}>
        {!loading ? (
          children
        ) : (
          <div key="auth-loading-spinner" className="flex items-center justify-center min-h-screen">
            {/* כאן תוכל לשים ספינר טעינה אם תרצה */}
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-500"></div>
          </div>
        )}
      </div>
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};